import userApi from "api/user";
import { Button, Col, Form, Input, Modal, Row } from "antd";
import { useState } from "react";
import { useTranslation } from "react-i18next";

export default function ModalChangePassword({ openNotificationWithIcon }) {
  const [openModal, setOpenModal] = useState(false);
  const [form] = Form.useForm();
  const { t } = useTranslation()

  const onCancel = () => {
    setOpenModal(false);
    form.resetFields();
  };

  const onFinish = async (values) => {
    try {
      const res = await userApi.changePassword(values);
      if (res.success) {
        onCancel();
        openNotificationWithIcon("success", t('notification'), t('changePasswordSuccess'));
      }
    } catch (error) {
      openNotificationWithIcon("error", t('error'), error?.response?.data?.message || t('hasError'));
    }
  };

  return (
    <>
      <a onClick={() => setOpenModal(true)}>{t('changePassword')}</a>
      <Modal
        open={openModal}
        title={t('changePassword')}
        centered
        footer={null}
        onCancel={onCancel}
        width={768}
        destroyOnClose
      >
        <Form form={form} onFinish={onFinish} layout="vertical">
          <Form.Item
            name="oldPassword"
            label={t('oldPassword')}
            required
            rules={[{ required: true }]}
          >
            <Input.Password />
          </Form.Item>
          <Form.Item
            name="newPassword"
            label={t('newPassword')}
            required
            rules={[{ required: true }]}
          >
            <Input.Password />
          </Form.Item>
          <Form.Item
            name="confirmPassword"
            label={t('newPassword')}
            required
            rules={[
              {
                required: true,
              },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (!value || getFieldValue("newPassword") === value) {
                    return Promise.resolve();
                  }
                  return Promise.reject(new Error(t('notMatchPassword')));
                },
              }),
            ]}
          >
            <Input.Password />
          </Form.Item>
          <Row gutter={16}>
            <Col span={8} offset={4}>
              <Form.Item>
                <Button style={{ width: "100%" }} htmlType="submit">
                  Ok
                </Button>
              </Form.Item>
            </Col>
            <Col span={8}>
              <Button style={{ width: "100%" }} onClick={onCancel}>
                {t('cancel')}
              </Button>
            </Col>
          </Row>
        </Form>
      </Modal>
    </>
  );
}
